// Projects List - Click to reveal gallery
class ProjectsList {
  constructor() {
    this.container = document.querySelector('.projects-list');
    if (!this.container) return;

    this.triggers = this.container.querySelectorAll('[data-project-trigger]');
    this.galleries = this.container.querySelectorAll('[data-project-gallery]');
    this.activeGallery = null;
    
    this.init();
  }

  init() {
    console.log('Projects List initialized');
    console.log('Found triggers:', this.triggers.length);
    console.log('Found galleries:', this.galleries.length);

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => this.handleClick(event));
    });

    // Fermer la galerie si on clique en dehors
    document.addEventListener('click', (event) => {
      if (this.activeGallery && !event.target.closest('.projects-list__item')) {
        this.closeAllGalleries();
      }
    });
  }

  handleClick(event) {
    event.stopPropagation();
    console.log('Click detected');
    
    const trigger = event.currentTarget;
    const projectId = trigger.getAttribute('data-project-trigger');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    console.log('Project ID:', projectId);
    console.log('Is expanded:', isExpanded);
    
    if (isExpanded) {
      // Si on clique sur le projet déjà ouvert, on le ferme
      this.closeAllGalleries();
    } else {
      // Sinon on ferme tout et on ouvre celui-ci
      this.closeAllGalleries();
      this.openGallery(trigger, projectId);
    }
  }

  openGallery(trigger, projectId) {
  console.log('Opening gallery:', projectId);
  
  // Close all galleries first
  this.closeAllGalleries();
  
  // Then open the clicked one
  trigger.setAttribute('aria-expanded', 'true');
  
  this.galleries.forEach(gallery => {
    if (gallery.getAttribute('data-project-gallery') === projectId) {
      gallery.classList.add('active');
      this.activeGallery = gallery;
      console.log('Gallery opened');
    }
  });
}


  closeAllGalleries() {
    console.log('Closing all galleries');
    this.triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    this.galleries.forEach(gallery => gallery.classList.remove('active'));
    this.activeGallery = null;
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProjectsList();
  });
} else {
  new ProjectsList();
}

